export default __webpack_public_path__ + "static/excel-sheet-data-b8e4a508a137551de4c876e5c0d73de4.png";